import React from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';

import { StaticImage } from '@nxte-nl/static-image';

import { versionDependent } from '../../images/versionDependentExport';
import { Typography } from '../Typography/Typography';
import styles from './FooterTopPart.module.css';

export const messages = defineMessages({
  footerTopPartText: {
    id: 'src.components.FooterTopPart.footerTopPartText',
    defaultMessage: 'Ordered on working days before 5:00 PM, shipped the same day.',
  },
  footerClockIconAlt: {
    id: 'src.components.FooterTopPart.footerClockIconAlt',
    defaultMessage: 'Footer clock icon',
  },
});

export const FooterTopPart: React.FC = React.memo(() => {
  const intl = useIntl();
  return (
    <section className={styles.wrapper}>
      <div className={styles.footerTopPart}>
        <StaticImage
          alt={intl.formatMessage(messages.footerClockIconAlt)}
          src={versionDependent.footerClockIcon.src}
          width={50}
          className={styles.icon}
        />

        <Typography className={styles.text} variant='body2'>
          <FormattedMessage {...messages.footerTopPartText} />
        </Typography>
      </div>
    </section>
  );
});

FooterTopPart.displayName = 'FooterTopPart';
